import React from "react";
import { useUserContext } from "../context/AuthContext";

const Greetings = () => {
  const { authUser } = useUserContext();

  const name = authUser?.firstname || "there";
  const hour = new Date().getHours();

  const getGreeting = () => {
    if (hour < 12) {
      return {
        text: "Good Morning",
        emoji: "☀️",
        message: "Let's make today productive.",
      };
    }

    if (hour < 18) {
      return {
        text: "Good Afternoon",
        emoji: "🌤️",
        message: "Keep pushing forward.",
      };
    }

    return {
      text: "Good Evening",
      emoji: "🌙",
      message: "Time to relax and reflect.",
    };
  };

  const greeting = getGreeting();

  return (
    <section className="pb-5 max-w-screen-md w-full">
      <div className="rounded-2xl border border-gray-100 bg-white px-5 py-4 shadow-sm">
        <div className="flex items-center gap-3">
        
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              {greeting.text},{" "}
              <span className="text-purple-600">{name}</span>
              <span className="text-lg">{greeting.emoji}</span>
            </h2>

            <p className="mt-1 text-sm text-gray-400">
              {greeting.message}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Greetings;